import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'idp-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent {
  @Output() iconClicked: EventEmitter<boolean> = new EventEmitter();
  @Input() labelTitle = '';
  @Input() labelSrOnly = false;
  @Input() srText = '';
  @Input() ariaRole = 'link';

  /** to emit an event when information icon is clicked */
  clicked() {
    this.iconClicked.emit(true);
  }
}
